export default "__VITE_ASSET__CVdUh7Gj__"